<template>
    <div>
        <HomeLayoutBack>
            <div class=" font-bold text-24 text-a-brown-502314 text-center pt-8">{{lbl.crownpoint.POINT}}</div>
            <div class=" mx-auto py-6 xl:px-36">
                <div class=" p-4 lg:grid lg:grid-cols-3 lg:rounded-2xl lg:border lg:border-a-brown-e7d7c1">
                    <Content
                        class=" text-a-brown-502314 lg:col-span-2"
                    ></Content>
                    <div class=" mx-auto pt-8 lg:p-2 lg:pt-0">
                        <div class=" text-center rounded-2xl bg-a-brown-e7d7c1 pt-6 text-a-brown-502314">
                            <div class=" font-bold text-24">{{lbl.crownpoint.DOWNLOAD_APPLCICATION}}</div>
                            <div class=" text-16 pt-2">{{lbl.crownpoint.Burger_King_Applications}}</div>
                            <div class=" pt-6 px-9 grid grid-cols-2">
                                <img class=" h-10 mx-auto" @click="clickAppStore()" src="../../../assets/icon/AppStore@3x.png"/>
                                <img class=" h-10 mx-auto" @click="clickGooglePlay()" src="../../../assets/icon/GooglePlay@3x.png"/>
                            </div>
                            <div class=" w-56 pt-5 mx-auto">
                                <img src="../../../assets/icon/Device_1@3x.png"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </HomeLayoutBack>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import HomeLayoutBack from "@/components/Layout/Page/HomeLayoutBack.vue"
import Content from '@/module/CrownPoint/component/content.vue';
export default {
    name: 'point',
    mixins: [LocaleMixin],
    components: {
        Content,
        HomeLayoutBack
    },
    methods: {
        clickAppStore: function() {
            window.location.replace("https://itunes.apple.com/us/app/burgerking-thailand/id1440299482?ls=1&mt=")
        },
        clickGooglePlay: function() {
            window.location.replace("https://play.google.com/store/apps/details?id=com.bzbs.burgerking")
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .content-page {
        padding-top: $topbar-height;
        min-height: 100vh;
    }
</style>
